import React, { useEffect, useState } from 'react';
import Icon from '../media/icon/icons';
import { apiRequest } from "../services/apiService";

const NotificationPopup = ({ isOpen, onClose, setNotificationCount }) => {
  const [notifications, setNotifications] = useState([]);
  const role = sessionStorage.getItem("role");

  useEffect(() => {
    const fetchNotifications = async () => {
      if (role === "client") return;
      try {
        const response = await apiRequest("api/v1/auth/tempusers", "GET");
        if (response.data) {
          // console.log("noti", response.data);
      //     setNotifications(response.data);
      //     setNotificationCount(response.data.length); 
      //   }
      // } catch (error) {
      //   console.error("Error fetching:", error);
      // }

           const sortedData = response.data.sort((a, b) => 
          new Date(b.created_at) - new Date(a.created_at)
        );

        setNotifications(sortedData);
        setNotificationCount(sortedData.length);
      }
    } catch (error) {
      console.error("Error fetching:", error);
    }
    };

    fetchNotifications();
  }, [role, setNotificationCount]);

  if (!isOpen) return null;

  const formatDate = (utcString) => {
  const date = new Date(utcString);
  const options = { month: 'short', day: '2-digit', year: 'numeric' };
  const datePart = new Intl.DateTimeFormat('en-US', options).format(date);

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${datePart} | ${hours}:${minutes}`;
};

  const handleNotificationRemove = (notificationId, e) => {
    e.stopPropagation();
    // Handle notification removal logic here
  };

  return (
    <>
      <div className={`notification-dropdown header-dropdowns ${isOpen ? 'open' : 'close'}`}>
        <div className="header-dropdowns-header">
          <div className="header-dropdowns-title">
              <Icon name='notification_bell_fill' width={20} height={20} color='#3B82F6'></Icon>
            <p>Notifications</p>
          </div>
          <button className="header-dropdowns-close-btn" onClick={e => { e.stopPropagation(); onClose(); }}>
            <Icon name='close_fill' width={20} height={20} color='#6B7280'></Icon>
          </button>
        </div>
        <div className="np-notification-content">
          {notifications.length === 0 ? (
            <p className='np-no-notifications'>No notifications</p>
          ) : (
            notifications.map((notification) => (
              <div key={notification.id} className="np-notification-row">
                <div className="np-notification-row-leftcol">
                  <div className="np-notification-title-blue-small">New signup</div>
                  <div className="np-notification-row-bottom">
                    <div className="np-notification-subtitle-small">{notification.company_name} | {notification.name}</div>
                    <span className="np-notification-date-small">{formatDate(notification.created_at)}</span>
                  </div>
                </div>
                <div className="np-notification-row-xcol" onClick={(e) => handleNotificationRemove(notification.id, e)}>
                    <Icon name="close_fill" width={16} height={16} color='#6B7280' className='np-remove-btn'/>
                 </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};
export default NotificationPopup;